import { render, staticRenderFns } from "./ShapeSelect.vue?vue&type=template&id=6e39c64a"
import script from "./ShapeSelect.vue?vue&type=script&lang=js"
export * from "./ShapeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports